/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
// eslint-disable-next-line import/extensions
import * as actionTypes from './ActionTypes';

export const dispatchFilterAndSortFun = (data) => ({
  type: actionTypes.SET_FILTER_AND_SORT_DATA,
  payload: data,
});

export const dispatchTableLoader = (value) => ({
  type: actionTypes.TABLE_ACTION_LOADER,
  payload: value,
});

export const clearReduxForFilterAndSort = (URL) => (dispatch, getState) => {
  const reduxObj = getState()?.sharedState.TableGridReducer?.filterAndSortList;
  if (Object.keys(reduxObj)?.length > 0) {
    const obj = Object.entries(reduxObj)?.filter((item) => {
      return item[1]?.activeURL !== URL;
    });
    let newObj = {};
    const obj1 = obj?.map((prop) => {
      newObj = {
        ...newObj,
        [prop[0]]: prop[1],
      };
      return prop;
    });
    dispatch(dispatchFilterAndSortFun(newObj));
  }
};
